import React, { Fragment, Component } from 'react';
import { translate } from '../Services/translation';

class FacetedSearchGroup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            collapsed: false,
            showLessItemCount: 25000,
            expanded: !!props.group.expanded || (
                Array.isArray(props.group.selectedOptions) &&
                props.group.selectedOptions.length > 0
            )
        };
        this.toggleShowMore = this.toggleShowMore.bind(this);
        this.expandFilters = this.expandFilters.bind(this);
    }

    componentDidMount() {
        const visible = this.refs.list.getBoundingClientRect().height !== 0;
        const tooMuchItem = this.props.group.options.length > this.state.showLessItemCount;
        visible && tooMuchItem && this.toggleShowMore();
    }

    toggleShowMore() {
        const topPos = this.refs.list.getBoundingClientRect().top;
        const lessBottomPos = this.refs.showLess.getBoundingClientRect().bottom;
        const moreBottomPos = this.refs.showMore.getBoundingClientRect().bottom;
        const setHeight = () => this.refs.list.style.height = `${ (this.state.collapsed ? lessBottomPos : moreBottomPos ) - topPos }px`;
        const toggleCollapse = () => {
            this.setState((prevState, props) => ({
                collapsed: !prevState.collapsed
            }),()=> {
                setHeight();
            });
        }
        if( !this.refs.list.style.height ) {
            setHeight();
            setTimeout(()=> {toggleCollapse()}, 0);
        }
        else {
            toggleCollapse();
        }
    }

    expandFilters() {
    this.setState(prevState => ({
        expanded: !prevState.expanded
    }));
    }

    render() {
        const { group, searchFacetChange } = this.props;
        return (
            <Fragment>
                <ul className={`faceted-search__group ${this.state.expanded ? "expanded" : ""}`} ref="list">
                    <li className="faceted-search__group-header-div" onClick={this.expandFilters}>
                        <h4 className="faceted-search__group-header" role="faceted-search-item-group">{group.label}</h4>
                        <span className="subnav__arrow">
                            <img src="/ui/images/arrow-down.svg" alt="Open nav icon" />
                        </span>
                    </li>
                    {group.options && group.options.map((item, itemIndex, array) => (
                        <li
                            key={`${item.label}-${itemIndex}`}
                            className="faceted-search__item"
                            role="faceted-search-item"
                            ref={itemIndex === this.state.showLessItemCount - 1 ? "showLess" : itemIndex === array.length - 1 ? "showMore" : null}
                        >
                            <FacetedFilterCheckbox item={item} group={group} searchFacetChange={searchFacetChange} />
                        </li>
                    ))}
                </ul>
                {group.options.length > this.state.showLessItemCount &&
                    <span className="faceted-search__show-more" onClick={this.toggleShowMore}>
                        {this.state.collapsed ? translate('filter.showmore') : translate('filter.showless')}
                    </span>
                }
            </Fragment>
        );
    }
}

const FacetedSearch = ({facetFilters, searchFacetChange, clearAllFacetFilters, navigationTheme, isDesktop }) => {
    const hasSelectedFilters = Array.isArray(facetFilters) && facetFilters.some(group => Array.isArray(group.selectedOptions) && group.selectedOptions.length > 0);
    const preservedParams = ['sort_by', 'q', 'page'];
    const hasFiltersInUrl = (() => {
        const currentParams = new URLSearchParams(window.location.search || '');
        return Array.from(currentParams.keys()).some(key => !preservedParams.includes(key));
    })();
    const canClearFilters = hasSelectedFilters || hasFiltersInUrl;

    const clearAllFilters = () => {
        if (!canClearFilters) {
            return;
        }
        clearAllFacetFilters();
    };

    return navigationTheme !== 'category' && (
    <ul className="faceted-search">
        {isDesktop ? (
            <li className="product-filter-header">
                <div className="filter-header-text">
                    <img src="/ui/images/filter-button-color-primary.svg" alt="Filter button icon" /><p className="filter-title">{translate('filter.title')}</p>
                </div>
                <button type="button" className="filter-clear-all" onClick={clearAllFilters} disabled={!canClearFilters}>{translate('filter.clear.all')}</button>
            </li>
        ) : (
            <>
                <li className="product-filter-header">
                    <div className="filter-header-text">
                        <p className="small-title filter-title">{translate('filter.title')}</p>
                    </div>
                    <button id="close-filter" className="close-filter-button"><img src="/ui/images/filter-close.svg" alt="Close filter icon"/></button>
                </li>
                <li>
                    <button type="button" className="filter-clear-all" onClick={clearAllFilters} disabled={!canClearFilters}>{translate('filter.clear.all')}</button>
                </li>
            </>
        )}
        {facetFilters && facetFilters.map((group, groupIndex, array) => (
            <FacetedSearchGroup key={`${group.label}-${groupIndex}`} group={group} searchFacetChange={searchFacetChange}/>
        ))}
    </ul>
)}

const FacetedFilterCheckbox = ({item, group, searchFacetChange}) => (
    <label className="faceted-filter" >
        <input className="faceted-filter__input" type="checkbox" onChange={event => searchFacetChange(group, item)} checked={group.selectedOptions != null && group.selectedOptions.includes(item.id)} />
        <span className="faceted-filter__label">
            {item.label}
            {!isNaN(item.quantity) && (item.quantity != null) &&
                <span className="faceted-filter__quantity">&nbsp;({item.quantity})</span>
            }
        </span>
    </label>
)

export default FacetedSearch;
